module.exports = __webpack_public_path__ + "img/google_light.1cdc8fce.svg";